import { BasisBadge } from "@/components/trust/BasisBadge";
import { ConfidenceIndicator } from "@/components/trust/ConfidenceIndicator";

function fmt(v) {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return typeof v === "number" ? v.toLocaleString("en-IN", { maximumFractionDigits: 2 }) : v;
}

export function BenchmarkTriple({ label, unit, actual, shouldbe, golden, basis = "modelled", confidence = "medium", limitedBy, testId }) {
  const gap1 = shouldbe != null && actual != null ? (shouldbe - actual) : null;
  const gap2 = golden != null && shouldbe != null ? (golden - shouldbe) : null;
  const lowConf = confidence === "low";
  const insufficient = confidence === "insufficient";

  return (
    <div className="space-y-1.5" data-testid={testId}>
      <div className="text-[10px] uppercase tracking-widest text-[var(--oim-text-dim)] font-heading">{label}</div>
      <div className="grid grid-cols-3 gap-2 font-mono-data">
        <div className={lowConf ? "opacity-70" : ""}>
          <div className="text-[9px] text-[var(--oim-text-dim)] uppercase">Actual</div>
          <div className="text-sm font-semibold text-[var(--oim-text)]">
            {insufficient ? "—" : fmt(actual)} <span className="text-[10px] text-[var(--oim-text-muted)]">{unit}</span>
          </div>
        </div>
        <div>
          <div className="text-[9px] text-[var(--oim-text-dim)] uppercase">Should-Be</div>
          <div className="text-sm font-semibold text-[var(--oim-text)]">
            {fmt(shouldbe)} <span className="text-[10px] text-[var(--oim-text-muted)]">{unit}</span>
          </div>
        </div>
        <div>
          <div className="text-[9px] text-[var(--oim-text-dim)] uppercase">Golden</div>
          <div className="text-sm font-semibold" style={{ color: "var(--oim-gold)" }}>
            {fmt(golden)} <span className="text-[10px] text-[var(--oim-text-muted)]">{unit}</span>
          </div>
        </div>
      </div>
      {(gap1 != null || gap2 != null) && (
        <div className="flex gap-4 text-[10px] text-[var(--oim-text-dim)] font-mono-data">
          {gap1 != null && <span>{gap1 > 0 ? "▼" : gap1 < 0 ? "▲" : "="} {fmt(Math.abs(gap1))} vs should-be</span>}
          {gap2 != null && <span>{fmt(Math.abs(gap2))} potential vs golden</span>}
        </div>
      )}
      {insufficient ? (
        <div className="text-[10px] font-heading uppercase text-[var(--oim-text-dim)]">INSUFFICIENT DATA</div>
      ) : (
        <div className="flex items-center gap-2">
          <BasisBadge basis={basis} />
          <ConfidenceIndicator level={confidence} limitedBy={limitedBy} />
        </div>
      )}
    </div>
  );
}
